import { setupWorker } from 'msw/browser';
import { handlers } from './handlers';

export const worker = setupWorker(...handlers);

export const startMockWorker = async () => {
  try {
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: `${import.meta.env.BASE_URL}mockServiceWorker.js`,
      },
    });
    console.info('[demo] MSW worker ready — all API calls are served from sample data.');
  } catch (err) {
    console.error('[demo] MSW worker failed to start', err);
  }
};
